import backstage from './backstageRoutes';
import collection from './collectionRoutes';
import discovery from './discoveryRoutes';
import listener from './listenerRoutes';
import payments from './paymentsRoutes';
import playback from './playbackRoutes';
import search from './searchRoutes';

export default {
  backstage,
  collection,
  discovery,
  listener,
  payments,
  playback,
  search,
};
